/* import __COLOCATED_TEMPLATE__ from './hidden-details.hbs'; */
import Component, { setComponentTemplate } from "@ember/component";
import { action } from "@ember/object";
import TEMPLATE from "./hidden-details.hbs";
export default setComponentTemplate(TEMPLATE, Component.extend(dt7948.p({
  expand() {
    this.set("expanded", true);
  }
}, [["method", "expand", [action]]])));